<template>
  <article>
    <section>
      <img :src="`https://admanawards.com/storage/app/img/judge/${data.judge_picture}`">
      <div class="box-content">
        <div class="box"></div>
        <div class="box-text">
          <h2>{{ data.name }}</h2>
          <span v-html="data.content"></span>
        </div>
      </div>
    </section>
  </article>
</template>

<script>
export default {
  props: {
    data: Object
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

article {
  section {
    img {
      width: 100%;
      height: auto;
      background-color: $light;
    }

    .box-content {
      .box {
        float: left;
        margin-top: 10px;
        width: 15px;
        height: 15px;
        background-color: $active;
      }

      .box-text {
        margin-left: 22px;
        font-size: 1rem;

        h2 {
          margin-bottom: 12px;
          font-size: 1.75rem;
        }

        span {
          opacity: 0.6;
          font-size: 1.25rem;
          line-height: 0.8;
        }
      }
    }
  }
}
</style>
